import React, {useMemo} from 'react'
import WizTag from '../../../../components/tag/WizTag'
import Text from '../../../../components/text/Text'
import {AnnounceContensType} from '../../../../pages/post/announcement/AnnounceCreate'
import {getRemovedMarkdown} from '../../../../utils/markdown'
import WizImage from '../../../../components/image/WizImage'
import moment, {now} from 'moment'

interface IProps {
    categories?: string[]
    announceContents: AnnounceContensType
    importantAt?: number
    thumbnail?: string
    onClickRemoveCategory?: (category?: string) => void
    onClickRemoveImportantAt?: () => void
}

const AnnouncementPreview: React.FC<IProps> = ({
    categories,
    announceContents,
    importantAt,
    thumbnail,
    onClickRemoveCategory,
    onClickRemoveImportantAt,
}) => {
    const removedPreviewContents = useMemo(() => getRemovedMarkdown(announceContents.content), [announceContents])

    const getCategory = (category: string) => {
        switch (category) {
            case 'announcement':
                return 'Official'
            case 'media':
                return 'Media'
            case 'event':
                return 'Events'
            case 'others':
                return 'Other'
            case 'important':
                return 'Important'
        }
    }

    return (
        <div className={'flex items-center justify-between overflow-hidden bg-white p-[10px]'}>
            <div className={'bg-white '}>
                <div className={'flex items-center space-x-[6px] mb-[8px]'}>
                    {importantAt > moment().unix() && (
                        <WizTag
                            onClick={onClickRemoveImportantAt}
                            textClassName={'bg-tag_red_light text-font_red font-normal cursor-pointer'}>
                            {getCategory('important')}
                        </WizTag>
                    )}
                    {categories &&
                        categories.length > 0 &&
                        categories.map(category => (
                            <WizTag
                                key={category}
                                onClick={() => onClickRemoveCategory(category)}
                                textClassName={'bg-icon_bg_black_5 text-font02 font-normal cursor-pointer'}>
                                {getCategory(category)}
                            </WizTag>
                        ))}
                </div>
                <div className={'w-full break-all overflow-hidden'}>
                    <Text className={'text-h4 text-font01 mb-[4px] break-words'}>{announceContents.title}</Text>
                    <Text className={'line-clamp-1 text-font02 text-body2'}>{removedPreviewContents}</Text>
                </div>
                <div className={'flex items-center space-x-[8px] mt-[15px]'}>
                    <Text className={'text-body3 text-font03'}>League of Traders EN</Text>
                    <Text className={'text-body3 text-font04'}>|</Text>
                    <Text className={'text-body3 text-font03'}>Sep 01, 2023 14:00</Text>
                </div>
            </div>
            {thumbnail && (
                <WizImage
                    src={thumbnail}
                    alt={thumbnail}
                    isResizeFit
                    className={`w-[198px] h-[110px] rounded-[5px] ml-[10px]`}
                />
            )}
        </div>
    )
}
export default AnnouncementPreview
